<template>
  <button type="button" class="ui-logout" @click="handleClick">
    <ui-icon
      size="18"
      :color="$colors.white"
      icon="fas fa-sign-out-alt"
    ></ui-icon>
  </button>
</template>

<script setup lang="ts">
import { useColors, useI18n, useLogout } from '@/composables';
import $emitter from '@/services/emitter';

const props = defineProps<{
  actionBeforeLogout?: () => void;
}>();

const emit = defineEmits<{
  (e: 'confirm'): void;
  (e: 'close'): void;
}>();

const $colors = useColors();
const { t } = useI18n();
const { logout } = useLogout();

const handleClick = () => {
  $emitter.emit('open-dialog', {
    name: 'ConfirmDialog',
    data: {
      confirmButtonText: t('Logout'),
      confirmButtonIcon: 'fas fa-sign-out-alt',
      message: t('Are you sure you want to logout?'),
      onConfirm: () => {
        emit('confirm');
        emit('close');
        props.actionBeforeLogout?.();
        logout();
      },
    },
  });
};
</script>

<style lang="scss">
.ui-logout {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
